// Mock data for Medical Coder Pro website

export const mockData = {
  hero: {
    headline: "Crack Your Medical Coding Interview with Confidence",
    subheadline: "Complete Medical Coding Interview Preparation Material for Freshers & Job Seekers",
    ctaPrimary: "Download Free Sample (30 Pages)",
    ctaSecondary: "Buy Full Version – ₹249 Only"
  },
  
  about: {
    title: "About Medical Coder Pro",
    description: "Medical Coder Pro is a Medical Coding Interview Preparation Material designed to help candidates crack Medical Coder job interviews. It covers all essential topics required for medical coding roles in a simple and easy-to-understand format."
  },
  
  features: [
    { id: 1, title: "ICD-10-CM", icon: "FileText" },
    { id: 2, title: "CPT", icon: "Clipboard" },
    { id: 3, title: "HCPCS Level II", icon: "BookOpen" },
    { id: 4, title: "All Body Systems", icon: "Activity" },
    { id: 5, title: "Medical Abbreviations & Meanings", icon: "FileSearch" },
    { id: 6, title: "Definitions", icon: "Book" },
    { id: 7, title: "Chapter-Specific Guidelines", icon: "ListChecks" },
    { id: 8, title: "Latest Updated Guidelines", icon: "RefreshCw" },
    { id: 9, title: "Diseases", icon: "Stethoscope" },
    { id: 10, title: "Subject Interview Questions", icon: "MessageSquare" },
    { id: 11, title: "General Interview Questions", icon: "HelpCircle" },
    { id: 12, title: "Interview Preparation Tips", icon: "Lightbulb" },
    { id: 13, title: "Sample Medical Coder Resume", icon: "FileText" }
  ],
  
  freeSample: {
    title: "Free 30-Page Sample Medical Coding Interview Material",
    format: "PDF Format",
    note: "No payment required",
    cta: "Download Free Sample PDF"
  },
  
  pricing: {
    originalPrice: 899,
    offerPrice: 199,
    offerText: "Limited-time offer",
    cta: "Download Full Version Now"
  },
  
  whyChoose: [
    { id: 1, title: "Beginner-Friendly", description: "Designed specifically for medical coding freshers with simple explanations", icon: "Users" },
    { id: 2, title: "Complete Syllabus", description: "Covers all essential interview topics in one comprehensive material", icon: "CheckCircle" },
    { id: 3, title: "Affordable Pricing", description: "One-time payment of just ₹199/- - Best value for money", icon: "BadgeIndianRupee" },
    { id: 4, title: "Instant Access", description: "Get immediate digital download after purchase", icon: "Zap" },
    { id: 5, title: "Job-Ready Content", description: "Real interview questions and professional resume samples included", icon: "Briefcase" }
  ],
  
  finalCTA: {
    title: "Start Your Medical Coding Career Today",
    subtitle: "Join hundreds of successful medical coders who prepared with our material",
    cta: "Get Full Interview Preparation Material @ ₹199"
  },
  
  faqs: [
    {
      id: 1,
      question: "What is Medical Coder Pro?",
      answer: "Medical Coder Pro is a comprehensive Medical Coding Interview Preparation PDF designed to help freshers and experienced candidates crack medical coder job interviews confidently."
    },
    {
      id: 2,
      question: "Who can use this PDF?",
      answer: "This material is ideal for:\n• Who has completed Coaching\n• Medical Coding Freshers\n• CPC / CCS / aspirants\n• Life science graduates\n• Anyone preparing for medical coding interviews"
    },
    {
      id: 3,
      question: "What topics are covered in this PDF?",
      answer: "The PDF covers:\n• ICD-10-CM (All Chapters & Guidelines)\n• CPT Coding\n• HCPCS Level II\n• All CPT Modifiers\n• All Body Systems\n• Medical Abbreviations & Definitions\n• Chapter-specific Guidelines\n• Diseases & Coding Concepts\n• Subject Interview Questions\n• General & HR Interview Questions\n• Interview Preparation tips\n• Sample resume"
    },
    {
      id: 4,
      question: "Is this material suitable for freshers?",
      answer: "Yes. This PDF is beginner-friendly and specially structured to help freshers understand concepts and prepare confidently for interviews."
    },
    {
      id: 5,
      question: "Is this a job guarantee material?",
      answer: "This is an interview preparation material, not a job placement service. It provides strong knowledge and interview questions to improve your chances of getting selected."
    },
    {
      id: 6,
      question: "What format will I receive after purchase?",
      answer: "You will receive a PDF file that is easy to access on mobile, tablet, and desktop."
    },
    {
      id: 7,
      question: "How many pages are included?",
      answer: "The material contains approximately 200+ pages of detailed content."
    },
    {
      id: 8,
      question: "How will I receive the PDF after payment?",
      answer: "After successful payment, the PDF will be downloaded and sent instantly via Email."
    },
    {
      id: 9,
      question: "Can I access this PDF on mobile?",
      answer: "Yes. The PDF is mobile-friendly and can be accessed anytime."
    },
    {
      id: 10,
      question: "Is this a one-time payment?",
      answer: "Yes. This is a one-time payment with lifetime access to the purchased material."
    },
    {
      id: 11,
      question: "Can I share this PDF with others?",
      answer: "No. This material is for personal use only. Sharing, reselling, or distributing is strictly prohibited."
    },
    {
      id: 12,
      question: "Do you provide a sample before purchase?",
      answer: "Yes. A sample PDF is available for free to download, so you can review the quality before purchasing."
    },
    {
      id: 13,
      question: "Is there any refund policy?",
      answer: "Due to the digital nature of the product, refunds are not available once the PDF is delivered."
    },
    {
      id: 14,
      question: "How much does the PDF cost?",
      answer: "The price is ₹199 only, making it affordable and value-packed for serious job aspirants."
    },
    {
      id: 15,
      question: "How can I contact support?",
      answer: "You can contact us through:\n• Website contact form\n• WhatsApp support\n• Email support"
    }
  ]
};
